// extracted by mini-css-extract-plugin
export var closeButton = "_10-3";
export var header = "_10-0";
export var link = "_10-1";
export var retryButton = "_10-2";